import Swiper, { Scrollbar } from "swiper";

import { InteractPlan } from "../components/InteractPlan";
import { AbonementView } from "../Views/AbonementView";
import { AbonementModel } from "../Models/AbonementModel";

Swiper.use([Scrollbar]);

export class AbonementController {
	constructor(view, model) {
		this.view = view;
		this.model = model;

		this.abonementSlider = null;
	}

	init() {
		if (this.model.state === "prices") this.initPricesStep();

		this.initSlider();

		this.setUpListeners();
		this.setUpSubscribers();
	}

	/**
	 * Устанавливает обработчики событии на странице
	 */
	setUpListeners() {
		this.view.$priceTable.on("mouseover", e => {
			if (!$(e.target).closest(this.view.$priceViewItem).length > 0) return false;

			const elem = $(e.target).closest(this.view.$priceViewItem);
			const firstView = elem.data("first-view");
			const secondViewList = elem.data("second-view").toString().split(", ");

			if (!(firstView && secondViewList)) return false;

			this.firstStadium.filter(firstView, "view_id");
			this.secondStadium.filter(secondViewList, "view_id");
		});

		this.view.$priceTable.on("mouseleave", e => {
			this.firstStadium.filter("none");
			this.secondStadium.filter("none");

			return false;
		});
	}

	/**
	 * Устанавливает подписчиков на событие
	 */
	setUpSubscribers() {}

	initPricesStep() {
		const stadiumData = {
			dragging: false,
			addViewBox: true,
		};

		/** Добавляем интерактив стадиону */
		this.firstStadium = new InteractPlan(
			$.extend(stadiumData, { svg: this.view.$firstStadium })
		);
		this.secondStadium = new InteractPlan(
			$.extend(stadiumData, { svg: this.view.$secondStadium })
		);
	}

	initSlider() {
		const activeSlide = $(".abonement-item_selected");

		this.abonementSlider = new Swiper(".js-abonement-slider", {
			slidesPerView: 3,
			scrollbar: {
				el: ".swiper-scrollbar",
			},
			breakpoints: {
				0: {
					slidesPerView: 1,
				},
				992: {
					slidesPerView: 2,
				},
				1200: {
					slidesPerView: 3,
				},
			},
			on: {
				touchMove: function () {
					$(".abonement-main__table-header").addClass("show-shadow");
				},
				touchEnd: function () {
					$(".abonement-main__table-header").removeClass("show-shadow");
				},
				imagesReady: () => {
					$(".js-abonement-slider").removeClass("loading");
				},
			},
		});

		/* Показываем активный слайд если он скрыт за контейнером */
		if (activeSlide.index() > 2) this.abonementSlider.slideTo(activeSlide.index());
	}
}

const abonement = new AbonementController(new AbonementView(), new AbonementModel());
abonement.init();
